// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/InitialScreen/InitialScreen.scss
// module id = 732
// module chunks = 0